import { Slot } from '@radix-ui/react-slot'
import { useTranslation } from 'react-i18next'

import { Access } from '@/entities/session'

import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'
import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

export const CreateGlobalPcSet = ({
	children,
}: {
	children: React.ReactNode
}) => {
	const { t } = useTranslation()

	const { showModal } = useModals()
	const handleOpenCreateGlobalPcSetModal = () => {
		ampli.globalPcSetCreateClicked()

		showModal('CREATE_GLOBAL_PC_SET')
	}

	return (
		<Access permissions={['CREATE_GLOBAL_PRICING_CAMPAIGNS']}>
			<Tooltip>
				<TooltipTrigger asChild>
					<Slot onClick={handleOpenCreateGlobalPcSetModal}>{children}</Slot>
				</TooltipTrigger>
				<TooltipContent>
					{t('global_set.add.tooltip', {
						defaultValue: 'Add global set',
					})}
				</TooltipContent>
			</Tooltip>
		</Access>
	)
}
